import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/template/field/type/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/template/field/type/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/template/field/type/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/template/field/type/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/template/field/type/delete/batch', {
    params: {
      ids
    }
  })
}
